// @flow
import React from "react";
import cx from "classnames";
import glamorous from "glamorous";
import isString from "voca";
import { isNumber } from "lodash";
import "./SvgIcon.scss";

type Size = "xxxs" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xl2";

type propsType = {
    path: string,
    fill?: ?string,
    className?: ?string,
    colorName?: ?string, // need to add names with flow
    size?: Size | number,
    color?: string,
    title?: string,
    onClick?: Function,
    style?: Object,
    dataTest?: string,
};

const GIcon = glamorous.div(({
	onClick, size, extClassName, colorName,
}) => cx("dib", extClassName, {
	"w-100 h-100": !size,
	pointer: onClick,
	[`box-${size || ""}`]: isString(size),
	[`fill-${colorName || ""}`]: isString(colorName),
}),
({ size, style }) => ({
	...style,
	width: isNumber(size) ? size : null,
	height: isNumber(size) ? size : null,
}));

const SvgIcon = ({
	path, fill, className, colorName, size, color, onClick, title, style, dataTest,
}: propsType) => <GIcon onClick={onClick} size={size} extClassName={className} colorName={colorName}
	style={style} title={title} data-test={dataTest}>
	<svg
		className="db"
		viewBox="0 0 24 24"
		preserveAspectRatio="xMidYMid"
		style={{ fill: fill || color }}>
		<path d={path}/>
	</svg>
</GIcon>;

SvgIcon.defaultProps = {
	fill: "",
};

export default SvgIcon;
